const modeEnum = Object.freeze({
    Edit: 1,
    Create: 2
  });
  
  export default modeEnum;